import {Component, ElementRef, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {select, Store} from '@ngrx/store';
import {AdminPanelState} from '../../store/reducers/admin-panel.reducer';
import {Subject} from 'rxjs';
import {AddCompanyComponent} from '../add-company/add-company.component';
import {UpdateCompanyComponent} from '../update-company/update-company.component';
import {take, takeUntil} from 'rxjs/operators';
import {SelectableSettings} from '@progress/kendo-angular-grid';
import {AdminPanelConfig} from '../../admin-panel.config';
import {getUserInfo} from '@shared/store/selectors/security.selector';
import {SmartGridService} from '@core/services/smart-grid.service';
import {InvalidateSmartGridAction} from '@shared/store/actions/smart-grid.actions';
import {UserInfo} from '@shared/models/user-info.model';
import {MatDialog} from '@angular/material/dialog';
import {BreadcrumbModel} from '@shared/models/breadcrumb.model';
import { PlatformCommand } from '@shared/commands/command-base';
import { Api } from '@shared/constants/common-field.constants';
import { CommandService } from '@core/services/command.service';
import { SnackBarService } from '@core/services/snack-bar.service';
import { FuseSplashScreenService } from '@barebone-fuse/@fuse/services/splash-screen.service';

@Component({
    standalone: false,
    selector: 'lib-company-content',
  templateUrl: './company-content.component.html',
  styleUrls: ['./company-content.component.scss']
})
export class CompanyContentComponent implements OnInit, OnDestroy {

  selectableSettings: SelectableSettings = {
    enabled: false,
    checkboxOnly: true
  };
  sourceType = 'Company';
  selectedItems: any[];
  userInfo: UserInfo;
  searchCompanyForm: any;
  unSubscribe$ = new Subject<void>();
  breadcrumbs: BreadcrumbModel[];
  constructor(public dialog: MatDialog,
              private elementRef: ElementRef,
              private formBuilder: FormBuilder,
              private store: Store<AdminPanelState>,
              private commandService: CommandService,
              private snackBarService: SnackBarService,
              private smartGridService: SmartGridService,
              private fuseSplashScreenService: FuseSplashScreenService,
  ) {
    this.selectedItems = [];
    this.breadcrumbs = [
      <BreadcrumbModel>{
        id: 'AdminPanel',
        title: 'Admin Panel',
        type: 'AdminPanel',
        relativeUrl: 'admin-panel/company',
      }, <BreadcrumbModel>{
        id: 'Company',
        title: 'Company',
        type: 'Company',
        relativeUrl: 'admin-panel/company',
      },
    ];
  }

  ngOnInit() {
    this.store.pipe(select(getUserInfo), takeUntil(this.unSubscribe$)).subscribe(u => {
      this.userInfo = u;
    });
    const config = AdminPanelConfig.getSmartGridConfig(this.sourceType);
    this.smartGridService.initDataProvider(this.sourceType);

    this.searchCompanyForm = this.formBuilder.group({
      search: [decodeURIComponent(config.Parameters.SEARCH_TEXT)]
    });
  }

  ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  searchCompanies(addClass = false) {
    if (addClass) {
      this.elementRef.nativeElement.querySelector('#searchButton').classList.add('mat-button-toggle-checked');
      this.elementRef.nativeElement.querySelector('#clearSearchButton').classList.remove('mat-button-toggle-checked');
    }

    let searchText = this.searchCompanyForm.controls['search'].value;
    if (searchText === undefined || searchText === null) {
      searchText = '';
    }
    AdminPanelConfig.setSearchText(this.sourceType, searchText);
    this.store.dispatch(new InvalidateSmartGridAction(this.sourceType, true, false, false));
  }

  clearSearchCompanies() {
    this.elementRef.nativeElement.querySelector('#searchButton').classList.remove('mat-button-toggle-checked');
    this.elementRef.nativeElement.querySelector('#clearSearchButton').classList.add('mat-button-toggle-checked');
    this.searchCompanyForm.controls['search'].setValue('');
    this.searchCompanies(false);
  }

  addCompany() {
    const dialogRef = this.dialog.open(AddCompanyComponent, {
      width: '600px',
      disableClose: true,
      data: {userName: this.userInfo.userName}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result.save) {
        const command = new PlatformCommand('AddCompanyPlatformCommand', Api.AdminPanel);
        command.setValue("Company", result.company);
        this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(res => {
            this.fuseSplashScreenService.hide();
            this.snackBarService.showToastNotification(res.fieldValues['SnackBarMessage'])
          }, err => {
            this.fuseSplashScreenService.hide();
            console.error(err);
            this.snackBarService.showError('Can not create company at the moment');
          });
      }
    });
  }

  onSelectionChanged(event) {
    this.selectedItems = event.allSelectedRows.map(function (obj) {
      return obj.dataItem;
    });
  }


  onValueChanged(event) {
    if (event.action && event.action.id && event.action.id === 'Edit') {
      this.updateCompany(event.item);
    }
  }

  updateCompany(item) {
    const dialogRef = this.dialog.open(UpdateCompanyComponent, {
      width: '600px',
      disableClose: true,
      data: {company: item.cells, userName: this.userInfo.userName}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result.save) {
        const command = new PlatformCommand('UpdateCompanyPlatformCommand', Api.AdminPanel);
        command.setValue("Company", result.company);
        this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(res => {
            this.fuseSplashScreenService.hide();
            this.snackBarService.showToastNotification(res.fieldValues['SnackBarMessage'])
          }, err => {
            this.fuseSplashScreenService.hide();
            console.error(err);
            this.snackBarService.showError('Can not create company at the moment');
        });
      }
    });
  }
}
